<template>
  <label class="flex items-center gap-2">
    <div class="mui-switch">
      <input
        v-bind="$attrs"
        type="checkbox"
        class="mui-switch__input"
        :checked="value"
        @change="update"
      />

      <i class="mui-switch__icon" />
    </div>

    <span class="text-small">{{ label }}</span>
  </label>
</template>

<script>
export default {
  props: {
    value: Boolean,

    label: String,

    /**
     * The value of the checked state
     */
    checkedValue: {
      type: [Boolean, String, Number, Date],
      default: true
    },

    /**
     * The value of the unchecked state
     */
    uncheckedValue: {
      type: [Boolean, String, Number, Date],
      default: false
    },
  },

  methods: {
    update(event) {
      const key = event.target.checked ? 'checkedValue' : 'uncheckedValue';

      this.$emit('input', this[key]);
    },
  },
};
</script>
